module.exports = __webpack_public_path__ + "static/media/achieve2.14fc2add.png";